import { ALL_ADDR_TYPES, ADDR_TYPE_META, sortRoles } from '../lib/customerAddress'

// "This address is used as ..." -- the ONE place that decides how an address's roles are picked. An address is typed once and
// ticked for every use it has (Operations + Invoice + Registered...), instead of being typed again per use.
// `taken` = role -> label of ANOTHER address of the same company that is currently primary for it; ticking "primary" here
// takes the role over from it, so the label is shown as a heads-up.
interface Props {
  roles: string[]
  primaryRoles: string[]
  onChange: (next: { roles: string[]; primary_roles: string[] }) => void
  taken?: Record<string, string>
}

export default function AddressRolesSelect({ roles, primaryRoles, onChange, taken = {} }: Props) {
  const toggleRole = (r: string) => {
    if (roles.includes(r)) {
      const next = roles.filter(x => x !== r)
      // An address needs at least one use.
      if (next.length === 0) return
      onChange({ roles: next, primary_roles: primaryRoles.filter(x => x !== r) })
    } else {
      // Ticking a use makes this the company's address for it when nobody holds that role yet.
      onChange({ roles: sortRoles([...roles, r]), primary_roles: taken[r] ? primaryRoles : sortRoles([...primaryRoles, r]) })
    }
  }
  const togglePrimary = (r: string) =>
    onChange({ roles, primary_roles: primaryRoles.includes(r) ? primaryRoles.filter(x => x !== r) : sortRoles([...primaryRoles, r]) })

  return (
    <div className="col-span-2">
      <label className="block text-xs font-medium text-gray-500 mb-1">Used as</label>
      <div className="grid grid-cols-1 gap-1">
        {ALL_ADDR_TYPES.map(r => {
          const on = roles.includes(r)
          const primary = primaryRoles.includes(r)
          return (
            <div key={r} className="flex items-center gap-3">
              <label className="flex items-center gap-2 w-40 cursor-pointer">
                <input type="checkbox" checked={on} onChange={() => toggleRole(r)} className="rounded" />
                <span className={`text-xs px-1.5 py-0.5 rounded ${on ? ADDR_TYPE_META[r]?.color : 'text-gray-500'}`}>{ADDR_TYPE_META[r]?.label ?? r}</span>
              </label>
              {on && (
                <label className="flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-300 cursor-pointer">
                  <input type="checkbox" checked={primary} onChange={() => togglePrimary(r)} className="rounded" />
                  Primary {ADDR_TYPE_META[r]?.label.toLowerCase()} address
                  {primary && taken[r] && <span className="text-amber-600">(replaces: {taken[r]})</span>}
                </label>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
